import { useAccountStore, useBaseAppDevStore } from "../stores";
import { LISTENER_CMDS } from "./constants";
import { getComponentInstance } from "./event.handlers";
import { msgData, isMobile } from "./utils";

export function customComponentHandler(data, iframeInstance) {
  const functionMappings = {
    [LISTENER_CMDS.CC_INITIALIZE]: initializeCustComp,
    [LISTENER_CMDS.CC_WATCH_PARAMS]: watchParams
  };
  return functionMappings[data.command](data, iframeInstance);
}

const initializeCustComp = async (data, iframeInstance) => {
  const accountDetails = await useAccountStore.getState().getAccountDetails();
  const { currentRole, pageId } = useBaseAppDevStore.getState().context;
  getComponentInstance(iframeInstance.componentId, { createOnFallback: true });
  iframeInstance.updateContext("pageId", pageId);
  iframeInstance.updateContext(
    "appId",
    useBaseAppDevStore.getState().currentAppId
  );
  return msgData(data, {
    appId: useBaseAppDevStore.getState().currentAppId,
    componentId: iframeInstance.componentId,
    pageId,
    user: {
      Name: accountDetails?.UserDetails?.Name,
      Email: accountDetails?.UserDetails?.Email,
      UserType: accountDetails?.UserDetails?.UserType,
      _id: accountDetails?.UserDetails?._id,
      Role: {
        _id: currentRole?._id,
        Name: currentRole?.Name
      }
    },
    envDetails: {
      isMobile: isMobile()
    },
    account: {
      _id: accountDetails?._id
    }
  });
};

const watchParams = async (data, iframeInstance) => {
  let componentInstance = getComponentInstance(iframeInstance.componentId, {
    createOnFallback: true
  });
  componentInstance.addEventListener(
    data.eventName,
    function onParamsChange(eventParams) {
      iframeInstance.postEventMessage(
        {
          target: data.id,
          eventName: data.eventName,
          eventConfig: data.eventConfig
        },
        eventParams
      );
    }
  );
  iframeInstance.sendParams(iframeInstance.params);
};
